module.exports = __webpack_public_path__ + "media/images/icon_performance-b80dd53208e1471b1d5fd6d7e3bc95a4.png";